interface SpinnerProps {
  customDimension?: string;
}

export default function Spinner({ customDimension }: SpinnerProps) {
  return (
    <div
      className={`flex items-center justify-center ${customDimension ? customDimension : "h-full"}`}
    >
      <div
        className={`border-[3px] border-gray-200 border-t-app-green rounded-full animate-spin ${customDimension ? customDimension : "w-10 h-10"}`}
      />
    </div>
  );
}
